import { render, staticRenderFns } from "./GridRecolecciones.vue?vue&type=template&id=746aa8d4&"
import script from "./GridRecolecciones.vue?vue&type=script&lang=js&"
export * from "./GridRecolecciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports